import { render, staticRenderFns } from "./OrganizationResourcesPane.vue?vue&type=template&id=d99c1020&"
import script from "./OrganizationResourcesPane.vue?vue&type=script&lang=ts&"
export * from "./OrganizationResourcesPane.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationResourcesPane.vue?vue&type=style&index=0&id=d99c1020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports